
export const shopItemOveral = (itemPaymentData) => ({
	type: 'itemOveral',
	payload: {
		itemPaymentData: itemPaymentData
	},
});

export const lastOne = (quantity) => ({
	type: 'lastOne',
	payload: {
		quantity: quantity
	},
});

export const bascketCarts = (bascketCarts) => ({
	type: 'carts',
	payload: {
		bascketCarts: bascketCarts
	},
});

export const cartsProduct = (cartsProduct) => ({
	type: 'cartsProduct',
	payload: {
		cartsProduct: cartsProduct
	},
});

export const productCount = (productCount) => ({
	type: 'productCount',
	payload: {
		productCount: productCount
	},
});

export const shopVitrinList = (data) => ({
	type: 'shopVitrinList',
	payload: {
		shopVitrinList: data
	}
})